<script setup>
import {computed} from 'vue'
import {useComponentsStore} from '@/stores/components'
import {useModalsStore} from '@/stores/modals'
import Button from "@/common/Button.vue"

const props = defineProps({
    id: {
        type: Number,
        required: true
    }
})

// Pinia Stores
const componentsStore = useComponentsStore()
const modalsStore = useModalsStore()

// --- Computed ---

const componentId = computed(() => {
    const tableName = `component_${props.id}`
    return componentsStore.componentIds[tableName] || 0
})

// --- Methods ---

const openFieldsModal = () => {
    modalsStore.show({
        componentName: 'ContentTypeFieldsModal',
        obj: {
            componentId: componentId.value
        }
    })
}
</script>

<template>
    <Button v-if="componentId" class="btn-sm" @click="openFieldsModal">
        Fields
    </Button>
</template>